import useApi from "./useApiRequest";
import { useMutation } from "react-query";


export const ReabrirSalida = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.put(`/administracion-inventario/salida/cerrar/documento/reapertura/reactivacion/${params}`, {}, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        reabrirSalidaMutation: mutation.mutate,
    };
}